import { object, number, array, string, rangeNumber } from '@gogame/schemas';

import {
  FILTER_CREATIVE_CREATED_BY,
  FILTER_CREATIVE_TYPES,
  FILTER_CREATIVE_LANGUAGES,
  FILTER_CREATIVE_LENGTH,
  FILTER_CREATIVE_MEDIA_TYPES,
  FILTER_CREATIVE_ORIENTATIONS,
  FILTER_CREATIVE_REQUESTED_BY,
  FILTER_CREATIVE_RESOLUTIONS,
  FILTER_CREATIVE_SIZES,
  FILTER_CREATIVE_AUTHORS,
  FILTER_CREATIVE_PRODUCTION_TYPES,
  FILTER_CREATIVE_ENHANCERS,
  FILTER_CREATIVE_OS,
  FILTER_CREATIVE_COLORS,
  FILTER_CREATIVE_INCLUDED_TAGS,
  FILTER_CREATIVE_EXCLUDED_TAGS,
  FILTER_CREATIVE_CREATION_PERIOD,
  FILTER_CREATIVE_CONCEPT_CREATION_PERIOD,
  FILTER_CREATIVE_STATUSES,
  FILTER_CREATIVE_END_CARD,
  FILTER_CREATIVE_TESTED,
  FILTER_IS_AI_CREATED,
} from '../constants';

import { CREATION_PERIOD_PRESETS } from '../presets';

export const creativeFiltersSchema = object({
  [FILTER_CREATIVE_CREATION_PERIOD]: array(string()).constants(
    CREATION_PERIOD_PRESETS
  ),
  [FILTER_CREATIVE_CONCEPT_CREATION_PERIOD]: array(string()).constants(
    CREATION_PERIOD_PRESETS
  ),
  [FILTER_CREATIVE_CREATED_BY]: array(number()),
  [FILTER_CREATIVE_TYPES]: array(number()),
  [FILTER_CREATIVE_LANGUAGES]: array(number()),
  [FILTER_CREATIVE_LENGTH]: rangeNumber(FILTER_CREATIVE_LENGTH),
  [FILTER_CREATIVE_MEDIA_TYPES]: array(number()),
  [FILTER_CREATIVE_ORIENTATIONS]: array(number()),
  [FILTER_CREATIVE_REQUESTED_BY]: array(number()),
  [FILTER_CREATIVE_RESOLUTIONS]: array(number()),
  [FILTER_CREATIVE_SIZES]: array(number()),
  [FILTER_CREATIVE_AUTHORS]: array(number()),
  [FILTER_CREATIVE_PRODUCTION_TYPES]: array(number()),
  [FILTER_CREATIVE_ENHANCERS]: array(number()),
  [FILTER_CREATIVE_OS]: array(number()),
  [FILTER_CREATIVE_COLORS]: array(number()),
  [FILTER_CREATIVE_INCLUDED_TAGS]: array(number()),
  [FILTER_CREATIVE_EXCLUDED_TAGS]: array(number()),
  [FILTER_CREATIVE_STATUSES]: array(number()),
  [FILTER_CREATIVE_END_CARD]: array(number()),
  [FILTER_CREATIVE_TESTED]: array(number()),
  [FILTER_IS_AI_CREATED]: number().default(0), // all
});
